<template>
  <div
    class="basic_wrap"
    style="overflow: hidden;"
  >
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('index.aboutUs') }}
      </div>
    </div>
    <div class="wrap_box">
      <router-link
        v-for="(v,k) in data.list"
        :key="k"
        :to="'about/' + v.id"
        class="item"
      >
        {{ v['title_'+lang] }}
      </router-link>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "Login",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_icon_type: 'about',
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/about').then((r) => {
					this.data = r.data;
				});
			},
		}
	};
</script>

<style lang="less" scoped>
    .red_top_bg{
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
	
	.wrap_box{
		margin: 10px;
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ececec;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: 700;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
		}
	}
</style>
